import React, { ReactNode, KeyboardEvent, MouseEvent, forwardRef } from "react";
import Loader from "../../assets/images/giphy.gif";

interface CustomButtonProps {
  title: any;
  children?: ReactNode;
  disabled?: any;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  className?: string;
  icon?: ReactNode;
  id?: string;
  onKeyDown?: (event: KeyboardEvent<HTMLButtonElement>) => void;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  color?: string;
  ref?: React.RefObject<HTMLButtonElement>;
}

// Use forwardRef to forward the ref to the button element
const CustomButton = forwardRef<HTMLButtonElement, CustomButtonProps>((props, ref) => {
  const { title, children, disabled, type, loading, className, icon, id, onKeyDown, onClick, color } = props;

  return (
    <button
      id={id}
      className={className}
      type={type}
      onKeyDown={onKeyDown}
      disabled={disabled || loading}
      onClick={onClick}
      color={color}
      ref={ref} // Ref is now correctly passed to the button
    >
      {loading ? (
        <div className="btn-loader">
          <img src={Loader} alt="loader" height={20} width={20} />
        </div>
      ) : (
        <>
          {icon}
          {title}
        </>
      )}
      {children}
    </button>
  );
});

export default CustomButton;
